{
  "TEXT_ALL_SELECTED": "Todos los seleccionados",
  "TEXT_CANCEL": "Cancelar",
  "TEXT_CLOSE": "Cerrar",
  "TEXT_CLEAR_ALL_FILTERS": "Borrar todos los filtros",
  "TEXT_CLEAR_ALL_GROUPING": "Borrar toda la agrupación",
  "TEXT_CLEAR_ALL_SORTING": "Borrar todo Ordenamiento",
  "TEXT_CLEAR_PINNING": "Descongelar columnas/filas",
  "TEXT_COLLAPSE_ALL_GROUPS": "Contraer todos los grupos",
  "TEXT_COLUMNS": "Columnas",
  "TEXT_COLUMN_RESIZE_BY_CONTENT": "Cambiar tamaño por contenido",
  "TEXT_COMMANDS": "Comandos",
  "TEXT_CONTAINS": "Contiene",
  "TEXT_COPY": "Copiar",
  "TEXT_EMPTY_DATA_WARNING_MESSAGE": "No hay datos para mostrar.",
  "TEXT_ENDS_WITH": "Termina con",
  "TEXT_EQUALS": "Igual",
  "TEXT_EQUAL_TO": "Es igual a",
  "TEXT_EXPAND_ALL_GROUPS": "Extiende todos los grupos",
  "TEXT_EXPORT_TO_CSV": "Exportar a formato CSV",
  "TEXT_EXPORT_TO_EXCEL": "Exportar a Excel",
  "TEXT_EXPORT_TO_PDF": "Exportar a PDF",
  "TEXT_EXPORT_TO_TAB_DELIMITED": "Exportar a formato de texto (delimitado por tabulaciones)",
  "TEXT_EXPORT_TO_TEXT_FORMAT": "Exportar a formato de texto",
  "TEXT_FILTER_SHORTCUTS": "Atajos de filtro",
  "TEXT_FORCE_FIT_COLUMNS": "Forzar ajuste de columnas",
  "TEXT_FREEZE_COLUMNS": "Congelar columnas",
  "TEXT_GREATER_THAN": "Mayor a",
  "TEXT_GREATER_THAN_OR_EQUAL_TO": "Mayor o igual a",
  "TEXT_GROUP_BY": "Agrupar por",
  "TEXT_HIDE_COLUMN": "Ocultar columna",
  "TEXT_LESS_THAN": "Menos a",
  "TEXT_LESS_THAN_OR_EQUAL_TO": "Menor o igual a",
  "TEXT_LOADING": "Cargando...",
  "TEXT_NO_ELEMENTS_FOUND": "No se encontraron elementos",
  "TEXT_NOT_CONTAINS": "No contiene",
  "TEXT_NOT_EQUAL_TO": "No es igual a",
  "TEXT_OK": "OK",
  "TEXT_OPTIONS": "Opciones",
  "TEXT_REMOVE_FILTER": "Quitar filtro",
  "TEXT_REMOVE_SORT": "Quitar ordenamiento",
  "TEXT_SAVE": "Guardar",
  "TEXT_SELECT_ALL": "Seleccionar todo",
  "TEXT_SORT_ASCENDING": "Ordenar ascendente",
  "TEXT_SORT_DESCENDING": "Ordenar descendente",
  "TEXT_STARTS_WITH": "Comienza con",
  "TEXT_X_OF_Y_SELECTED": "# de % seleccionados",
  "TEXT_BLANK_VALUES": "Valores en blanco",
  "TEXT_NON_BLANK_VALUES": "Valores no en blanco",
  "TEXT_FUTURE": "Futuro",
  "TEXT_ITEMS": "elementos",
  "TEXT_ITEMS_PER_PAGE": "elementos por página",
  "TEXT_ITEMS_SELECTED": "elementos seleccionados",
  "TEXT_LAST_UPDATE": "Última actualización",
  "TEXT_NEXT_20_DAYS": "Próximos 20 días",
  "TEXT_OF": "de",
  "TEXT_PAGE": "Página",
  "TEXT_PAST": "Pasado",
  "TEXT_REFRESH_DATASET": "Actualizar conjunto de datos",
  "TEXT_SYNCHRONOUS_RESIZE": "Cambio de tamaño sincrónico",
  "TEXT_TODAY": "Hoy",
  "TEXT_TOGGLE_FILTER_ROW": "Mostrar/Ocultar filtros",
  "TEXT_TOGGLE_PRE_HEADER_ROW": "Alternar fila de preencabezado",
  "TEXT_TECHNICAL_NAMES_REPORT": "Ver Nombres Técnicos",
  "TEXT_RESIZE_ALL_BY_CONTENT": "Cambiar tamaño por contenido"
}
